<template>
  <div class="contract">
    <div class="card-header bg-default">
      {{ contract.name }}
      <span class="badge" :class="randomLabel(contract.type)">
        {{ contractType }}
      </span>
      <span class="badge" :class="{
        'badge-success': contract.publicFleet,
        'badge-dark': !contract.publicFleet
      }">
        {{ contract.publicFleet ? 'Public Fleet' : 'Private Fleet' }}
      </span>
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <strong>Contract Period: </strong>
        {{ contract.contractStart | short_date_format }} - {{ contract.contractEnd | short_date_format }}
      </li>
    </ul>
    <div class="card-body">
      <p><strong>Contract Percent:</strong> {{ contract.contractSplit }}%</p>
      <p><strong>Per Annum Contract Increase:</strong> {{ contract.perAnnumIncrease }}%</p>
      <p><strong>Permitted KM:</strong> {{ contract.permittedKm | pretty_number }} km/yr</p>
      <p><strong>Additional KM Fee:</strong> {{ contract.additionalKmFee | to_dollar_amount }} per/km</p>
    </div>
    <div class="card-footer clearfix text-right">
      <router-link class="btn btn-primary btn-sm" :to="{ path: `/contracts/terms/view/${contract.uuid}` }">
        <span class="fa fa-search fa-fw"></span> View Details
      </router-link>
      <router-link class="btn btn-primary btn-sm" :to="{ path: `/contracts/terms/edit/${contract.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
import { randomLabel } from '@/util/helpers'

export default {
  name: 'Contract',
  props: {
    object: {
      type: Object
    }
  },
  data () {
    return {
      contract: {
        uuid: '',
        name: '',
        type: '',
        contractSplit: 0.00,
        publicFleet: true,
        contractStart: new Date(),
        contractEnd: new Date(),
        permittedKm: 0,
        additionalKmFee: 0.00,
        perAnnumIncrease: 0.00
      }
    }
  },
  computed: {
    contractType () {
      let matchCamels = new RegExp(/[A-Z\d]+(?![a-z])|[a-zA-Z][^A-Z\d\-_.\n]*/, 'g')
      function camelToTitle (match) {
        return `${match[0].toUpperCase()}${match.substr(1)} `
      }
      return this.contract.type.replace(matchCamels, camelToTitle)
    }
  },
  mounted () {
    this.contract = this.object
  },
  methods: {
    randomLabel (label) {
      return randomLabel(label)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Contract.vue